import PendoRadioGroup from '../../components/radio-group/pendo-radio-group.vue.js';
import PendoRadio from '../../components/radio/pendo-radio.vue.js';
import PendoActionCard from '../../components/action-card/pendo-action-card.vue.js';

var script = {
  name: 'PendoLayoutTypeChooser',
  components: {
    PendoRadio,
    PendoRadioGroup,
    PendoActionCard
  },
  props: {
    layoutType: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select-layout-type'],
  data() {
    return {
      layoutOptions: [{
        value: 'overlay',
        title: 'Overlay',
        subtitle: 'Guide appears above the page’s content and can be activated by a badge, event, or automatically on page load. Think classic modals, tool tips, polls, or multi-step tours.',
        icon: 'https://cdn.pendo.io/img/guides/guides-overlay-layout.svg'
      }, {
        value: 'embedded',
        title: 'Embedded',
        subtitle: 'Guide appears in-line with the page’s content, contained in an existing element and activated automatically on page load. Great for contextual info, upsells, or dynamic content.',
        icon: 'https://cdn.pendo.io/img/guides/guides-embedded-layout.svg'
      }]
    };
  },
  methods: {
    handleCardClick(type) {
      if (!this.disabled) {
        this.$emit('select-layout-type', type);
      }
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-layout-type-chooser.vue2.js.map
